import { render, staticRenderFns } from "./BaseHour.vue?vue&type=template&id=3e57dc3f"
import script from "./BaseHour.vue?vue&type=script&lang=js"
export * from "./BaseHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e57dc3f')) {
      api.createRecord('3e57dc3f', component.options)
    } else {
      api.reload('3e57dc3f', component.options)
    }
    module.hot.accept("./BaseHour.vue?vue&type=template&id=3e57dc3f", function () {
      api.rerender('3e57dc3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/BaseHour.vue"
export default component.exports